import { getValue, RemoteConfig } from "firebase/remote-config";

export function hashUidToBucket(uid: string): number {
  let h = 0;
  for (let i = 0; i < uid.length; i++) {
    h = (Math.imul(31, h) + uid.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % 100;
}

export function isFastPathEnabledForUser(
  rc: RemoteConfig,
  uid: string
): boolean {
  const raw = getValue(rc, "onboarding_fast_path_percent").asString();
  const pct = parseInt(raw, 10);
  if (Number.isNaN(pct) || pct <= 0) return false;
  if (pct >= 100) return true;
  return hashUidToBucket(uid) < pct;
}

export function getExperimentName(rc: RemoteConfig): string {
  return (
    getValue(rc, "onboarding_experiment_name").asString() ||
    "onboarding_flow_v1"
  );
}

export function getExperimentVariantLabel(fastPath: boolean): string {
  return fastPath ? "fast_path" : "full_wizard";
}
